// removed by extract-text-webpack-plugin
module.exports = {"resetButton":"boxCp _1SlZ0","spinnerContainer":"_3srgZ _3oB5M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/loadingError/style.css
// module id = 898
// module chunks = 0